<template>
    <div>
        <el-button type="primary" v-print="printData">打 印</el-button>
        <div id="printInfo">
                <!-- <div class="emptyNode">
                </div> -->

                <div class="exhibit" v-for="(item,index) in showInfo">
                    <div class="infoNode" style="display: flex;margin-left: 4cm">
                         <div class="showERCodeNode">
                            <QRcode
                                width="170"
                                height="170"
                                :content="item.订单号"
                                :load="true"
                            ></QRcode>
                            <div style="text-align: center;">入馆二维码</div>
                        </div>
                        <div class="flexNode">
                            <div class="showInfoNode">
                                <div class="flexNode">
                                    <div class="infodes">日期/DATE：</div>
                                    <span>{{ date }}</span>
                                </div>
                                <div class="flexNode">
                                    <div class="infodes">商品名称/GOODS：</div>
                                    <span>{{ item.订单明细[0].名称 }}</span>
                                </div>
                                <div class="flexNode">
                                    <div class="infodes">票价/PRICE：</div>
                                    <span>{{ item.价格 }}元</span>
                                </div>
                                <div class="flexNode">
                                    <div class="infodes">数量/NUMBER：</div>
                                    <span>{{ item.数量 }}张</span>
                                </div>
                                 <div class="flexNode">
                                     <div class="infodes">订单号/ORDER ID:</div>
                                    <span>{{ item.订单号 }}</span>
                                </div>
                                <div style="display: flex;align-items: center;margin-top: 0.3cm">
                                    <div style="">扫码购票/BUY TICKETS：</div>
                                    <img style="margin-left: 20px;width: 2.1cm;height: 2.1cm" src="../../assets/img/cyCode.png"/>
                                </div>
                                <!-- <div v-if="method == '2'">温馨提示：请使用微信扫描二维码取票，并使用畅游景德镇小程序中的畅游码入园</div>
                                <div v-else>温馨提示：请出示此二维码,闸机处扫码入馆</div> -->
                            </div>

                        </div>



                    </div>
                </div>
            </div>
    </div>

</template>

<script>
export default {
  name: "goods",
  data() {
    return {
      showInfo: [],
      date: this.$route.query.date,
      title: '',
      orderTypeOptions: [],
      orderType: '',
      printData: {
        id: 'printInfo',
        popTitle: "",
        extraHead: "",
        url: ""
      }
    };
  },
  created() {

    let showInfoStr = localStorage.getItem('tickets')
    this.showInfo = JSON.parse(showInfoStr)
    console.log(this.date, this.showInfo)

    this.getOrderTypeOptions()
  },
  methods: {
    getOrderTypeOptions() {
      let id = '2e8ac8b3-e201-4c29-91d6-c09deb7785a9'
      let that = this
      that.$axios({
          url: `/mall/enumDetail?id=${id}&timestemp=${ new Date().getTime() }`,
          method: "GET",
      })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach(o => {
                if (o.Value == that.showInfo.支付方式) {
                    that.orderType = o.Key
                }
            })
          } else {
            that.$message.warning(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },
    // recordPrint(){
    //   this.$axios({
    //     method: "post",
    //     url: "/order/getTicket",
    //     data: {
    //       memberid: this.userId||window.sessionStorage.getItem("userId")||'0001',
    //       orderid: this.orderNum,
    //       auditID:window.sessionStorage.getItem("userId"),
    //       auditName:window.sessionStorage.getItem("userName")
    //     },
    //   })
    // }
  },
};
</script>

<style scoped>
@page{
    size: landscape;
}
.exhibit {
    width: 16cm;
    height: 8cm;
    padding: 0.3cm;
    padding-top: 0cm;
    page-break-after:always
}
.emptyNode {
    width: 100%;
    height: 0.2cm;
}
.infoNode {
    height: 6cm;
    width: 100%;
}
.showInfoNode {
    width: 100%;
    font-size: 0.4cm;
    margin-left: 1cm;
}
.showInfoNode .infodes {
    width: 5cm;
}
.showInfoNode .smallInfodes {
    font-size: 1mm;
}
.subInfoNode {
    width: 95%;
    height: 3.5cm;
    font-size: 1mm;
    margin: 0.2cm;
}
.showERCodeNode {
    /* width: 100%; */
    /* margin-left: 1cm; */
}

.flexNode {
    display: flex;
}
.remark {
    font-size: 12px;
}
</style>
